import { useContext } from 'react';
import { LocaleContext, LocaleType } from '../contexts/localeContext';
import langConfig from '../../config/lang';

const useLang = (): LocaleType & { defaultLang: boolean } => {
    const lang = useContext(LocaleContext);
    return {
        ...lang,
        defaultLang: lang.value === langConfig.defaultLang,
    };
};

export { useLang };
